import {skipToken} from '@reduxjs/toolkit/query';

import {isNotNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {PurchasePriceRuleScope, useGetTrimLevelsQuery} from '@dms/api/sales';

import {getSinglePurchasePriceRuleMake} from '../utils/getSinglePurchasePriceRuleMake';
import {resolvePurchasePriceRuleLabel} from '../utils/resolvePurchasePriceRuleLabel';
import {usePurchasePriceRuleCatalogue} from './usePurchasePriceRuleCatalogue';

/**
 * Returns a lookup that resolves the catalogue keys of a rule scope to labels. The lookup returns
 * the raw key until the labels are loaded.
 */
export function usePurchasePriceRuleScopeLabels(scope: PurchasePriceRuleScope) {
  const {data: catalogue} = usePurchasePriceRuleCatalogue();

  // Trims are allowed only with exactly one make; without model families the catalogue returns
  // the trims of the whole make.
  const trimMake = getSinglePurchasePriceRuleMake(scope.makes);

  const {data: trims} = useGetTrimLevelsQuery(
    isNotNilOrEmpty(scope.trims) && isNotNil(trimMake)
      ? {make: trimMake, modelFamilies: scope.modelFamilies}
      : skipToken
  );

  return (key: string) => resolvePurchasePriceRuleLabel({key, catalogue, trims});
}
